export default "__VITE_ASSET__CjUjRRBi__"